/**
 * FavoriteAndShare
 * 
 * @Author: Focci
 * @Date: 2023-10-31 16:34:12
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-31 16:34:12
 */

'use client'

import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useApp from '@hook/useApp'

const HasCountForSocial = dynamic(() => import(
  '@page/property/favorite-and-share/HasCountForSocial'
), { ssr: false })

export default function FavoriteAndShare({
  house = {}
}) {
  const { isMobile } = useApp()
  return (
    <div 
      className="hidden md:block"
      style={{ minHeight: '49px' }}
    >
      {!isMobile && <HasCountForSocial house={house} />}
    </div>
  )
}

FavoriteAndShare.propTypes = {
  house: PropTypes.object,
}
